function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import { Body, CallToAction } from "../../atoms";
import { ArrowRight } from "../../icons";
import { NavigationList, Section } from "../../molecules";
export function SidebarContent(param) {
    var introduction = param.introduction, navigation = param.navigation, callToAction = param.callToAction, className = param.className, enableLines = param.enableLines, children = param.children;
    return /*#__PURE__*/ React.createElement(Section, {
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container grid grid-cols-1 grid-flow-row auto-rows-auto gap-5 md:grid-cols-[1fr_2fr]"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "md:pr-5 md:sticky md:top-[8rem]"
    }, !!introduction && /*#__PURE__*/ React.createElement(Body, {
        className: "prose md:prose-md mb-8 text-brand-primary-base"
    }, introduction), !!(navigation === null || navigation === void 0 ? void 0 : navigation.length) && /*#__PURE__*/ React.createElement(NavigationList, {
        variant: "sections",
        className: "mb-8",
        items: navigation
    }), !!callToAction && /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement(CallToAction, _extends({
        linkVariant: "big",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
    }, callToAction))))), /*#__PURE__*/ React.createElement("div", null, children)));
}

//# sourceMappingURL=SidebarContent.js.map